import { useEffect, useState } from "react"
import { useForm } from "react-hook-form";
import AuthService from "../../services/AuthService";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function Login(){
    const {register, handleSubmit, formState: {errors}} = useForm();
    const [error, setError] = useState('');
    const [alert, setAlert] = useState(false);
    const [showPassword, setShowPassword] = useState(true);
    const {auth, login} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogin = async (data) => {
        try{

            const response = await AuthService.login({data});
            if(response.status === 200 ){
                login(response.data.data.token);
                setTimeout(() => {
                    navigate(location.state?.from?.pathname || "/dashboard");
                }, 1000)   
            }else{
                setAlert(true);
                setError(response.message)
                console.log(response.message);
            }
        }catch(error){
            setAlert(true);
            setError(error.message);
            console.error("Error on login:", error);
        }
    }
    const handleShowPassword = async (data) => {
        setShowPassword(!showPassword);
    }
    useEffect(() => {
        if (auth) {
            const redirectTo = location.state?.from?.pathname || "/dashboard";
            navigate(redirectTo, { replace: true });
        }
       document.getElementsByTagName('body')[0].className = 'd-flex align-items-center bg-auth border-top border-top-2 border-primary'; 
    }, [auth, navigate, location]);

    return (
        <>
            <div className="container">
                <div className="row justify-content-center">
                        <div className="col-12 col-md-5 col-xl-4 my-5">
                            <h1 className="display-4 text-center mb-3">
                            Sign in
                            </h1>
                            {alert && (
                                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                    <strong> {error}!</strong>
                                    <button type="button" onClick={() =>setAlert(false)} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>
                            )}
                            <form onSubmit={handleSubmit(handleLogin)}>
                                <div className="form-group">
                                    <label className="form-label">
                                    Email Address
                                    </label>
                                    <input type="email" {...register('email', {required: "Email is required", pattern: {value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "Please enter a valid email address"}})} className={`form-control ${errors.email ? 'is-invalid' : ''}`} placeholder="name@example.com"/>
                                    {errors.email && <div className="text-danger">{errors.email.message}</div>}
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col">
                                            <label className="form-label">
                                                Password
                                            </label>
                                        </div>
                                        <div className="col-auto">
                                            <NavLink to="/forget-password" className="form-text small text-body-secondary">
                                                Forgot password?
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="input-group input-group-merge">
                                        <input type={!showPassword ? "text" : "password"} {...register('password', {required: "Password is required"})} className={`form-control ${errors.password ? 'is-invalid' : ''}`} placeholder="Enter your password" />
                                        <span className="input-group-text">
                                            <i className={`fe fe-eye${!showPassword ? '-off' : ''}`} onClick={handleShowPassword} role="button" style={{ cursor: 'pointer' }}></i>
                                        </span>
                                    </div>
                                    {errors.password && <div className="text-danger">{errors.password.message}</div>}
                                </div>
                                <button className="btn btn-lg w-100 btn-primary mb-3">
                                    Sign in
                                </button>
                            </form>
                        </div>
                </div>
            </div>
        </>
    )
}